export const TABLE = {
  CSV: 1,
  BACKEND: 2,
};

export const columnTitles = [
  {
    title: 'TT',
    dataIndex: 'id',
  },
  {
    title: 'Tên khách hàng',
    dataIndex: 'name',
  },
  {
    title: 'Tuổi khách hàng',
    dataIndex: 'age',
  },
  {
    title: 'Quốc tịch',
    dataIndex: 'nationality',
  },
  {
    title: 'Đánh giá',
    dataIndex: 'comment',
  },
  {
    title: 'Trạng thái',
    dataIndex: 'status',
  }
];
